<template>
  <div>
    <header class="bg-white">
      <b-container fluid class="px-md-5 py-3">
        <b-row v-if="backTo">
          <b-col>
            <router-link
              :to="backTo"
            >‹ {{backText}}</router-link>
            <hr/>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8">
            <h2>{{pageTitle}}</h2>
          </b-col>

          <b-col lg="4" class="text-lg-right text-sm-nowrap mt-lg-0">
            <slot name="actions"></slot>
          </b-col>
        </b-row>
      </b-container>
    </header>

    <b-container fluid class="px-md-5 py-5">
      <slot></slot>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'HeaderPageLayout',
  props: [
    'pageTitle',
    'backTo',
    'backText'
  ]
}
</script>
